import { Box, Button } from '@mui/material';
import { BoxProps } from '@mui/material/Box';
import { ButtonProps } from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import React from 'react';

// Page Container - specific to companies page
export const PageContainer: React.ComponentType<BoxProps> = styled(Box)(({ theme }) => ({
  padding: theme.spacing(1),
  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(0.5),
  },
}));

// Header section containing title and action button
export const PageHeader: React.ComponentType<BoxProps> = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(2),
  marginBottom: theme.spacing(1),
  marginRight: theme.spacing(1),
  alignItems: 'center',
  justifyContent: 'space-between',
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
}));

// Title section with fixed width
export const TitleSection: React.ComponentType<BoxProps> = styled(Box)(() => ({
  flex: '0 0 25%',
}));

// Button container with responsive positioning
export const ActionButtonContainer: React.ComponentType<BoxProps> = styled(Box)(({ theme }) => ({
  marginLeft: 'auto',
  [theme.breakpoints.down('sm')]: {
    marginLeft: 0,
  },
}));

// Create company button with consistent styling
export const CreateCompanyButton: React.ComponentType<ButtonProps> = styled(Button)(
  ({ theme }) => ({
    minWidth: '50%',
    height: '40px',
    textTransform: 'none',
    borderRadius: theme.spacing(3),
    fontWeight: 600,
    marginTop: theme.spacing(0.5),
    [theme.breakpoints.down('sm')]: {
      height: '40px',
    },
  })
);
